// Import normalize.css from npm package
import 'normalize.css';

// Import custom styles
import './styles.css';
import './homepage.css';

// Only geometric accents reveal; all reading content is visible without JS.
const motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
let accentObserver;
const syncAccents = () => {
  accentObserver?.disconnect();
  document.querySelectorAll('.homepage .accent-pending').forEach(element => {
    element.classList.remove('accent-pending');
  });
  if (motionPreference.matches || !('IntersectionObserver' in window)) return;
  accentObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.remove('accent-pending');
      accentObserver.unobserve(entry.target);
    });
  }, { threshold: 0.15 });
  document.querySelectorAll('.homepage .home-chapter, .homepage .home-book-cover').forEach(element => {
    if (element.getBoundingClientRect().top < window.innerHeight) return;
    element.classList.add('accent-pending');
    accentObserver.observe(element);
  });
};
syncAccents();
motionPreference.addEventListener('change', syncAccents);
window.addEventListener('pagehide', () => accentObserver?.disconnect());
window.addEventListener('pageshow', syncAccents);
